import get from 'lodash/get';
import React from 'react';

import { Col, Row } from '../../../node_modules/antd';
import I18n from '../../i18n';
import AppContext from '../../services/Context';
import styled from '../../styled-components';
import Icon from '../Icon';

type PropType = {
    type: string;
    className?: string;
    name: string;
    label?: string;
    items?: any;
    nameComp?: string;
    placeholder?: string;
    value?: any;
    valueBtn?: any;
    withError?: boolean;
    disabled?: boolean;
    addorn?: any;
    setFieldValue: Function;
    setTouched: Function;
    onFocus: Function;
    onBlur: Function;
};

const TextFieldSettings = (props: PropType) => (
    <AppContext.Consumer>
        {({ theme, locale }) => (
            <InputWrapper
                theme={theme}
                className={`goepik-component-padding form-input-wrapper_${props.name} ${props.className || ''}`}
            >

                <Row>
                    <Col sm={12} md={12} xl={12}>
                        <span style={{fontWeight: 'bold'}} >{I18n.l('form.taskflowschedule.labels.representsline')}</span>

                    </Col>
                    <Col sm={12} md={12} xl={12}>
                        <span style={{fontWeight: 'bold'}}>{I18n.l('form.taskflowschedule.labels.representscolumn')}</span>

                    </Col>
                </Row>

                <Input
                    theme={theme}
                    style={{ marginRight: '50px' }}
                    className={`form-input_${props.name} ${props.className || ''}`}
                    type={props.type}
                    name={props.name}
                    placeholder={I18n.l('form.taskflowschedule.labels.representslinePlaceholder')}
                    // value={props.value}
                    disabled={props.disabled}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        props.setFieldValue(props.name, e.target.value);
                        props.setTouched({ [props.name]: true });
                    }}
                />
                <Input
                    theme={theme}
                    className={`form-input_${props.name} ${props.className || ''}`}
                    type={props.type}
                    name={props.nameComp}
                    placeholder={I18n.l('form.taskflowschedule.labels.representscolumnPlaceholder')}
                    // value={props.value}
                    disabled={props.disabled}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        props.setFieldValue(props.nameComp, e.target.value);
                        props.setTouched({ [props.name]: true });
                    }}
                />
                {props.addorn &&
                    props.addorn.right && (
                        <Addorn theme={theme} className={props.disabled ? 'disabled' : ''}>
                            {props.addorn.right}
                        </Addorn>
                    )}
                {props.addorn &&
                    props.addorn.rightIcon && (
                        <Addorn theme={theme} className={props.disabled ? 'disabled' : ''}>
                            <Icon name={props.addorn.rightIcon} />
                        </Addorn>
                    )}
            </InputWrapper>
        )}
    </AppContext.Consumer>
);

const InputWrapper = styled.div`
  widht: 100%
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  ${({ theme }) => get(theme, 'form.inputWrapper')};

  &.search {
    ${({ theme }) => get(theme, 'form.searchWrapper')};
  }
  &.auth-style {
    ${({ theme }) => get(theme, 'form.authWrapper')};
  }
`;

const Input = styled.input`
  background: #fff;
  flex: 1;
  ${({ theme }) => get(theme, 'form.input')};

  &.search {
    ${({ theme }) => get(theme, 'form.search')};
  }
  &.auth-style {
    ${({ theme }) => get(theme, 'form.auth')};
  }
`;

const Addorn = styled.span`
  flex: 0;
  padding: 6px 4px;
  text-align: center;

  &:first-of-type {
    ${({ theme }) => get(theme, 'form.addornLeft')};
    padding-right: 0;
  }
  &:last-of-type {
    ${({ theme }) => get(theme, 'form.addornRight')};
    padding-left: 0;
  }
  &.disabled {
    background: #f2f2f2;
    color: #888;
  }
`;

const ButtonStyle = styled.div`
flex-flow: row nowrap;
align-items: center;
justify-content: space-between;
${({ theme }) => get(theme, 'form.inputWrapper')};

&.search {
  ${({ theme }) => get(theme, 'form.searchWrapper')};
}
&.auth-style {
  ${({ theme }) => get(theme, 'form.authWrapper')};
}
button {
    
    border-radius: 0;
    

    &:first-of-type {
      border-radius: 10px 0 0 10px;
      margin-left: 10px;
       
    }
    &:last-of-type {
      border-radius: 0 10px 10px 0;
    }

    

  }
`;

export default TextFieldSettings;
